import { getModeledSegments as getStoreItems } from 'selectors'
import { useSelector } from 'react-redux'

export function useSegments(): { imported: any[], fixtures: any[] } {
  const imported: any[] = useSelector(getStoreItems)

  return { imported, fixtures: [] }
}

export function useSegmentById(id: string) {
  const { imported } = useSegments()
  const segment = imported.find(item => item.id === id)

  return segment
}